<template>
  <ul class="subMenu navbar">
    <li class="profileMenu">
      <router-link :to="{ name: 'MainFormClub' }">
        <i class="fa fa-bars"></i>
        Fiche du club
      </router-link>
    </li>
    <li class="profileMenu">
      <router-link :to="{ name: 'Membres' }">
        <i class="fa fa-bars"></i>
        Membres
      </router-link>
    </li>
    <li class="profileMenu">
      <router-link :to="{ name: 'Recapitulatifs' }">
        <i class="fa fa-bars"></i>
        Récapitulatifs ABFT
      </router-link>
    </li>
    <li class="profileMenu">
      <router-link :to="{ name: 'ClubLabelisation' }">
        <i class="fa fa-bars"></i>
        Labélisation
      </router-link>
    </li>

    <li class="profileMenu" v-if="getClub.rights.can_register_member">
      <router-link :to="{ name: 'OrderList' }">
        <i class="fa fa-bars"></i>
        Mes commandes MyABFT
      </router-link>
    </li>
    <!--    <li class="profileMenu" v-if="getClub.rights.can_register_member">-->
    <!--      <router-link :to="{name: 'Inscriptions'}">-->
    <!--        <i class="fa fa-bars"></i>-->
    <!--        ISC (BETA)-->
    <!--      </router-link>-->
    <!--    </li>-->
    <!--<li class="profileMenu"><a><i class="fa fa-bars"></i> FAQ</a></li>-->

    <li class="drowdown pull-right">
      <a
        href="#"
        class="dropdown-toggle"
        data-toggle="dropdown"
        role="button"
        aria-expanded="false"
        ><span class="caret"></span
      ></a>
      <ul class="dropdown-menu" role="menu">
        <li
          v-if="
            getMember.clubsMyAbft != null && getMember.clubsMyAbft.length > 0
          "
          class="header"
        >
          Mes clubs:
        </li>
        <li v-for="(club, index) in getMember.clubsMyAbft">
          <a
            @click.prevent="
              goToClubForm({ id: club.club_id, club_slug: club.club_slug })
            "
            >{{ club.club }}</a
          >
        </li>

        <hr
          v-if="
            getMember.clubsMyAbft != null && getMember.clubsMyAbft.length > 0
          "
        />
        <li>
          <a @click.prevent="goToProfile()" href="">Retour à mon profil</a>
        </li>
        <hr />
        <li>
          <a @click.prevent="logout()" href="">Déconnexion</a>
        </li>
      </ul>
    </li>

    <li
      class="profileMenu  pull-right"
      v-if="getClub.rights.can_register_member"
    >
      <a
        class="dropdown-toggle btn-cart"
        data-toggle="dropdown"
        role="button"
        aria-expanded="false"
      >
        <i class="fa fa-shopping-cart"></i>
        <span
          data-toggle="tooltip"
          title=""
          class="badge bg-light-blue"
          :data-original-title="getNumberOfItemsInCart()"
          >{{ getNumberOfItemsInCart() }}</span
        >
      </a>
      <ul class="dropdown-menu" role="cart">
        <template v-for="(item, index) in getCart">
          <li v-if="item != null" class="header">
            {{ $getTermIndex(index) }}:
          </li>
          <li
            v-for="(club, id) in item"
            class="product"
            v-if="index == 'licence_club'"
          >
            1 x licence annuelle {{ currentYear() }} - {{ club.club }}
          </li>
          <li
            v-for="(obj, id) in item"
            class="product"
            v-if="index == 'licence_renew'"
          >
            1 x {{ obj.member.fullName }}
          </li>
          <hr />
        </template>
        <li>
          <a
            class="text-center"
            style="font-weight: bold"
            @click.prevent="goToCart"
          >
            Voir le panier
          </a>
        </li>
      </ul>
    </li>
  </ul>
</template>

<script type="text/babel">
import Auth from "@/auth";
import { mapGetters, mapActions } from "vuex";
import moment from "moment/moment";

var _ = require("lodash");

export default {
  data() {
    return {};
  },
  methods: {
    ...mapActions({
      setIdClubSelected: "setIdClubSelected",
      setStepOrder: "setStepOrder"
    }),
    goToCart: function() {
      this.setStepOrder({ step: "step1", value: false });
      this.setStepOrder({ step: "step2", value: false });
      this.setStepOrder({ step: "step3", value: false });
      this.setStepOrder({ step: "step4", value: false });
      this.$router.push({ name: "Panier" });
    },
    isDev: function() {
      return process.env.NODE_ENV === "development";
    },
    logout: function() {
      Auth.logout();
    },
    currentYear: function() {
      return moment().year();
    },
    goToClubForm: function(object) {
      this.setIdClubSelected(object.id);
      this.$router.push({
        name: "MainFormClub",
        params: {
          club: object.club_slug
        }
      });
    },
    //
    // getTermIndex: function (term) {
    //   return this.$getTermIndex(term)
    // },
    goToProfile: function(id) {
      this.setIdClubSelected(null);
      this.$router.push({ name: "Profile" });
    },
    getNumberOfItemsInCart: function() {
      let quantity = 0;
      if (_.has(this.getCart, "licence_renew"))
        _.map(this.getCart.licence_renew, item => (quantity += 1));
      if (_.has(this.getCart, "licence_club"))
        _.map(this.getCart.licence_club, item => (quantity += 1));
      return quantity;
    }
  },
  mounted: function() {
    // console.log(process.env.NODE_ENV)
  },
  components: {},
  computed: {
    ...mapGetters({
      getCart: "getCart",
      getMember: "getMember",
      getClub: "getClub"
    })
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Club/Subnavbar.vue